module.exports = "<section id=\"page-bar\">\r\n  <p>\r\n    {{pageName}}\r\n  </p>\r\n</section>\r\n"